export const button_41 = {
    default: {
        backgroundColor: '#E31B22',
        color: '#fff !important',
        boxShadow: '0 3px 0 0 #B5151B',
    }
}